import _styled from "styled-components";
const _excluded = ["selectedItems", "itemToString", "children", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import { defaultLabelGetter } from '../../helpers/defaultGetters';
const Selected = _ref => {
  let {
      selectedItems,
      itemToString = defaultLabelGetter,
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  let text;
  if (selectedItems && selectedItems.length === 1) {
    text = itemToString(selectedItems[0]);
  }
  if (selectedItems && selectedItems.length > 1) {
    text = T.translate('SELECTED', {
      count: selectedItems.length
    });
  }
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    $_css: [theme.typography.labelMedium, {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: 'inherit',
      pointerEvents: 'none',
      userSelect: 'none',
      flex: 1
    }, style]
  }), text, children);
};
export default Selected;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Selected___StyledDiv",
  componentId: "sc-1cy5px1-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Selected.js.map